import React from "react";
import { ArrowBackCircle } from "react-ionicons";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@popperjs/core";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import constantURI from "../URI";
import stylesASAP from "./stylesASAP";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesMed from "../MedRep/stylesMed";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import { set, get } from "idb-keyval";
import ReactToPrint from "react-to-print";

import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer } from "recharts";
import formatAmount from "../Functions/FormatCurrency";

export default class Report extends React.Component {
  constructor() {
    super();
    this.state = {
      authenticate: false,
      fromDate: "",
      toDate: "",
      showAlert: false,
      clients: [],
      showClients: false,
      selectedClient: 0,
      disableClient: false,
      getButton: false,
      loading: false,
      showRequiredAlert: false,
      alertString: "",
      requiredFields: { fromDate: true, toDate: true },
      noData: true,
      clientsCopy: [],
      alertOffline: false,
      token: "",
      customer: "",
      alertUndefined: false,
      nodata: false,
      userId: -1,
      selectedType: 0,
      clientIndex: -1,
      clickedButton: 0,
      isChecked: false,
      client: [],

      Data: [],
      dataaa: [
        { id: 1, name: "John Doe", age: 28, city: "New York" },
        { id: 2, name: "Jane Smith", age: 34, city: "Los Angeles" },
        { id: 3, name: "Sam Green", age: 23, city: "Chicago" },
        { id: 4, name: "Anna Brown", age: 41, city: "Miami" },
      ],
      selectedItemId: null,
      Headers: [],
      types: [
        "Select your type",
        "Collection report",
        "Daily summary report",
        "Local transaction report",
        "Local daily visits",
        "Local daily routed visits",
        "Local daily report",
      ],
      dailySummaryReport: [],
      localDailyVisits: [],
    };
    // this.printableDivRef = React.createRef();
    this.printableRef = React.createRef();
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";

    const returningFromDetails =
      localStorage.getItem("ReportReturning") === "true";
    if (returningFromDetails) {
      localStorage.removeItem("ReportReturning");
      const storedFromDate = JSON.parse(localStorage.getItem("ReportFromDate"));
      const storedToDate = JSON.parse(localStorage.getItem("ReportToDate"));
      const storedData = JSON.parse(localStorage.getItem("ReportByType"));
      const restoredData =
        storedData && Array.isArray(storedData) && storedData.length !== 0
          ? storedData
          : [];
      await this.setState({
        fromDate: storedFromDate ? storedFromDate : new Date(),
        toDate: storedToDate ? storedToDate : new Date(),
        getButton: restoredData.length !== 0,
        Data: restoredData,
      });
    }

    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    const username = JSON.parse(localStorage.getItem("Username"));
    this.setState({ username: username });
    const token = localStorage.getItem("Token");

    const SelectedClient = JSON.parse(localStorage.getItem("SelectedClient"));
    const SelectedClientDetails = JSON.parse(localStorage.getItem("SelectedClientDetails"));
    const userId = JSON.parse(localStorage.getItem("UserId"));
    const GetReportByType =
      constantURI() +
      "GetReportByType?token=" +
      token +
      "&user=" +
      this.state.username +
      "&fromdate=" +
      this.state.fromDate +
      "&todate=" +
      this.state.toDate +
      "&selectedClient=" +
      this.state.selectedClient +
      "&ReportTypeId=" +
      this.state.selectedType;
    const dailySummaryReport = JSON.parse(
      localStorage.getItem("DailySummaryReport")
    );
    const localDailyVisits = JSON.parse(
      localStorage.getItem("LocalDailyVisits")
    );

    await this.setState({
      token: JSON.parse(token),
      userId: JSON.parse(userId),
      dailySummaryReport: dailySummaryReport,
      localDailyVisits: localDailyVisits,
      SelectedClient: SelectedClient,
      SelectedClientDetails : SelectedClientDetails,
      settingArray: JSON.parse(localStorage.getItem("SettingArray") || "[]"),
      userId: userId,
    });
    //ReadClients from indexDB
    await this.readData();
  }

  readData = async () => {
    try {
      // Use 'get' method from idb-keyval to read Clients from IndexedDB
      const data = await get("Clients");

      if (data) {
        // Use find() to get the client object that matches the selected client ID
        const selectedClient = data.find(
          (client) => client.id === this.state.SelectedClient
        );

        if (selectedClient) {
          // Set the state with the selected client object
          await this.setState({
            client: selectedClient,
            loading: false,
          });

          console.log("Selected Client from IndexedDB:", selectedClient);
        } else {
          console.log("Selected client not found in IndexedDB.");
        }
      } else {
        console.log("Clients not found in IndexedDB.");
      }
    } catch (error) {
      console.error("Error reading Clients from IndexedDB:", error);
    }
  };

  showClients = () => {
    this.setState({ showClients: true, clientIndex: -1 });
  };

  closeClients = () => {
    this.setState({ showClients: false });
  };

  showClients = () => {
    this.setState({ showClients: true, clientIndex: -1 });
  };

  closeClients = () => {
    this.setState({ showClients: false });
  };

  onS1 = (buttonNumber) => {
    this.setState({ selectedType: 1, clickedButton: buttonNumber });
  };
  onS2 = (buttonNumber) => {
    this.setState({ selectedType: 2, clickedButton: buttonNumber });
  };
  onS3 = (buttonNumber) => {
    this.setState({ selectedType: 3, clickedButton: buttonNumber });
  };
  onS4 = (buttonNumber) => {
    this.setState({ selectedType: 4, clickedButton: buttonNumber });
  };
  onS5 = (e) => {
    this.setState({ selectedType: 5 });
  };
  onS6 = (e) => {
    this.setState({ selectedType: 6 });
  };
  onS7 = (e) => {
    this.setState({ selectedType: 7 });
  };
  onS8 = (e) => {
    this.setState({ selectedType: 8 });
  };
  handleClick = () => {
    this.setState({ isChecked: !this.state.isChecked });
  };

  onSearch = async (text) => {
    var values = await SearchFilterFunction(
      text,
      this.state.clients,
      this.state.clientsCopy,
      this.state.noData
    );
    this.setState({ clients: values.items, noData: values.noData });
  };

  // onSelectClient = async (id) => {
  //   await this.setState({ clients: this.state.clientsCopy, getButton: false });
  //   await this.state.clientsCopy.map(async (item, index) => {
  //     if (id === item.id)
  //       await this.setState({
  //         clientIndex: index,
  //         selectedClient: id,
  //         getButton: false,
  //       });
  //   });
  //   await localStorage.setItem(
  //     "SelectedClient",
  //     JSON.stringify(this.state.selectedClient)
  //   );
  //   this.closeClients();
  // };

  onChangeCustomer = (e) => {
    this.setState({ customer: e.target.value });
    if (e.target.value === "")
      this.setState({ ...(this.state.requiredFields.HCP = false) });
    else this.setState({ ...(this.state.requiredFields.HCP = true) });
  };

  //onChangeReportType = async (e) => {
  //    var itemsSelected = e.target.options;
  //    var values = [];
  //    var texts = [];
  //    for (var i = 0, l = itemsSelected.length; i < l; i++) {
  //        if (itemsSelected[i].selected) {
  //            values.push(itemsSelected[i].value);
  //            texts.push(itemsSelected[i].text);
  //        }
  //    }
  //    await this.setState({ reportTypeInput: values, getButton: false });
  //    if (values === "")
  //        this.setState({ ...this.state.requiredFields.type = false })
  //    else
  //        this.setState({ ...this.state.requiredFields.type = true, ...this.state.requiredFields.HCP = true })
  //}

  onSelectFromDate = async (date) => {
    // await this.setState({ fromDate: date, getButton: false });
     let fromdDate = "";
  if (date) {
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    fromdDate = `${mm}-${dd}-${yyyy}`;
  }
  await this.setState({ fromDate: fromdDate, getButton: false });
    console.log(fromdDate)
    if (date === "")
      this.setState({ ...(this.state.requiredFields.fromDate = true) });
    else this.setState({ ...(this.state.requiredFields.fromDate = true) });
  };

  onSelectToDate = async (date) => {
    // await this.setState({ toDate: date, getButton: false });
         let todDate = "";
  if (date) {
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    todDate = `${mm}-${dd}-${yyyy}`;
  }
    await this.setState({ toDate: todDate, getButton: false });
    console.log(todDate)
    if (date === "")
      this.setState({ ...(this.state.requiredFields.toDate = true) });
    else this.setState({ ...(this.state.requiredFields.toDate = true) });
  };

  closeClientAlert = () => {
    this.setState({ showAlert: false });
  };

  showClientAlert = () => {
    this.setState({ showAlert: true });
  };

  onGetReport = async () => {
    var toFill = false;
    var alertString = "";
    Object.keys(this.state.requiredFields).map(async (item, index) => {
      if (!this.state.requiredFields[item]) {
        toFill = true;
        alertString += item + ", ";
        await this.setState({ alertString: alertString });
      }
    });

    if (toFill === true) {
      this.setState({ showRequiredAlert: true });
    } else {
      this.setState({
        loading: false,
        showRequiredAlert: false,
        getButton: true,
      });
      this.getReport();
    }
  };

  getReport = async () => {
    const username = JSON.parse(localStorage.getItem("Username"));
    this.setState({ username: username });
    const token = JSON.parse(localStorage.getItem("Token"));
    const userId = JSON.parse(localStorage.getItem("UserId"));
    const SelectedClientDetails = JSON.parse(localStorage.getItem("SelectedClientDetails"));
    const GetReportByType =
      constantURI() +
      "GetLedger?clientCode=" +
      SelectedClientDetails.Ref +
      "&token=" +
      token +
      "&user=" +
      userId +
      "&fromDate=" +
      this.state.fromDate +
      "&toDate=" +
      this.state.toDate;

    await _post(GetReportByType).then((response) => {
      return response.json().then(async (data) => {
        if (data !== undefined) {
          localStorage.setItem("ReportByType", JSON.stringify(data));
          await this.setState({ Data: data });
        }
      });
    });
  };

  // handlePrint = () => {
  //   const printContents = this.printableDivRef.current.innerHTML;
  //   const originalContents = document.body.innerHTML;

  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // };

  handlePrint = () => {
    this.printableRef.current.handlePrint();
  };

  handleDetails = (id) => {
    console.log(id);
    localStorage.setItem("IdClientDetails", JSON.stringify(id));
    localStorage.setItem("ReportFromDate", JSON.stringify(this.state.fromDate));
    localStorage.setItem("ReportToDate", JSON.stringify(this.state.toDate));
    localStorage.setItem("ReportByType", JSON.stringify(this.state.Data));
    localStorage.setItem("ReportReturning", "true");
    this.props.history.push("./StatmentDetails");
  };

  handleItemClick = (id) => {
    // Toggle the selected item
    this.setState((prevState) => ({
      selectedItemId: prevState.selectedItemId === id ? null : id,
    }));
  };

  render() {
    console.log(this.state.client);


    const currencyDisplay =
      localStorage.getItem("DefaultCurrencyName") ||
      (this.state.client !== undefined && this.state.client.currency_id
        ? this.state.client.currency_id[1]
        : "");
    if (!this.state.loading) {
      return (
        <div
          className="container-fluid v-100"
          style={
            this.state.items !== undefined && this.state.getButton
              ? stylesASAP.reportcolor
              : stylesASAP.reportcolor
          }
        >
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className="btn"
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}
          {!this.state.showRequiredAlert ? null : (
            <div className="col alert alert-danger">
              {this.state.alertString} are required fields that should be
              filled.
            </div>
          )}
          {!this.state.alertOffline ? null : (
            <div className="col alert alert-danger">
              {" "}
              Please Connect To the internet.
            </div>
          )}
          {!this.state.nodata ? null : (
            <div className="col alert alert-danger"> No Data Found !!!</div>
          )}
          <div className="row pt-3" style={stylesASAP.above}>
            <div className="col">
              <ArrowBackCircle
                className="btn"
                onClick={() => this.props.history.push("./TransactionsPage")}
                color={"#6C757D"}
                height="50px"
                width="50px"
              />
            </div>
          </div>
          <div className="row">
            {" "}
            <label className="h1 text-center  mb-5 ">
              <u>
                <b>Statment of account</b>
              </u>
            </label>
          </div>

          <div className="container my-5">
            {/* Button Section */}

            {/* Date Picker Section */}
            <div className="row d-flex justify-content-between align-items-center p-4 rounded-4 shadow-lg bg-light">
              {/* From Date Picker */}
              <div className="col-md-5 mb-4 mb-md-0">
                <label className="form-label text-muted fs-5">From Date</label>
                {/* <DatePicker
                  className="form-control rounded-3 border-2 border-secondary shadow-sm"
                  selected={this.state.fromDate}
                  onChange={(date) => this.onSelectFromDate(date)}
                  dateFormat="MM-dd-yyyy"
                /> */}
                <DatePicker
  selected={this.state.fromDate ? new Date(this.state.fromDate) : null}
  onChange={this.onSelectFromDate}
  dateFormat="MM-dd-yyyy"
/>
              </div>

              {/* To Date Picker */}
              <div className="col-md-5">
                <label className="form-label text-muted fs-5">To Date</label>
                {/* <DatePicker
                  className="form-control rounded-3 border-2 border-secondary shadow-sm"
                  selected={this.state.toDate}
                  onChange={(date) => this.onSelectToDate(date)}
                  dateFormat="MMMM d, yyyy"
                /> */}
                <DatePicker
  selected={this.state.toDate ? new Date(this.state.toDate) : null}
  onChange={this.onSelectToDate}
  dateFormat="MM-dd-yyyy"
/>
              </div>
            </div>

            <div className="d-flex justify-content-end mb-4 shadow-lg">
              <button
                className="btn btn-primary btn-lg shadow-lg rounded-3 px-5 py-3 fw-semibold transition-all hover-shadow"
                data-toggle="modal"
                data-target="#myModal"
                onClick={this.onGetReport}
              >
                Get Report
              </button>
            </div>
          </div>

          <div className="row" ref={this.printableRef} id="printablediv">
            {/* Client ID */}
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label htmlFor="clientId" className="form-label">
                  Client ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="clientId"
                  value={this.state.client.id}
                  readOnly
                />
              </div>
            </div>

            {/* Client Name */}
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label htmlFor="clientName" className="form-label">
                  Client Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="clientName"
                  value={this.state.client.name}
                  readOnly
                />
              </div>
            </div>

            {/* Email */}
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label htmlFor="clientEmail" className="form-label">
                  Adress
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="clientEmail"
                  value={this.state.client.city}
                  readOnly
                />
              </div>
            </div>

            {/* Phone Number */}
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label htmlFor="clientPhone" className="form-label">
                  Phone Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="clientPhone"
                  value={this.state.client.phone}
                  readOnly
                />
              </div>
            </div>

            {/* Phone Number */}
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label htmlFor="clientcurrency" className="form-label">
                  Currency
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="clientcurrency"
                  value={currencyDisplay}
                  readOnly
                />
              </div>
            </div>
          </div>

          <style jsx>{`
            .hover-shadow:hover {
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            }

            .btn-primary {
              background-color: #007bff;
              border-color: #007bff;
            }

            .btn-primary:hover {
              background-color: rgb(0, 101, 179);
              border-color: rgb(0, 100, 133);
            }

            .bg-light {
              background-color: #f8f9fa !important;
            }
          `}</style>

          {/* <div className="col-12 ">
            
         
              
               
                  <div
                    className="  btn btn-primary text-center"
                    style={{ float: 'right' }}
                    data-toggle="modal"
                    data-target="#myModal"
                    height="150px"
                    width="150px"
                    onClick={this.onGetReport}
                  >
                    Get Report
                  </div>
            
          
             
          </div>

          

          <div className=" row mt-5 m-1 border border-2 Box-Shadow">
          
            

              <div className="col text-center mt-2">
                <h6>From Date </h6>
                <DatePicker
                  className="form-control"
                  selected={this.state.fromDate}
                  onChange={(date) => this.onSelectFromDate(date)}
                 
                />
              </div>
              <div className="col text-center mt-2">
                <h6>To Date </h6>
                <DatePicker
                  className="form-control"
                  selected={this.state.toDate}
                  onChange={(date) => this.onSelectToDate(date)}
                 
                  
                />
              </div>
            
             
         
            
          </div> */}

          {/* <div
            class="table-responsive mt-5 "
            ref={this.printableDivRef}
            id="printableRef"
          >
            <table class="table table-striped">
              <thead>
                <tr>
                  {this.state.headers.map((item, index) => {
                    return <th className="th">{item}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {this.state.data.map((item, index) => {
                  return (
                    <React.Fragment key={item.Id}>
                      <tr
                        className="tr"
                        onClick={() => this.handleItemClick(item.Id)}
                      >
                        {this.state.headers.map((header, index) => {
                          return (
                            <td>
                              {Object.entries(item).map(([key, value]) => (
                                <div>
                                  {header === key ? <div> {value}</div> : null}
                                </div>
                              ))}
                            </td>
                          );
                        })}
                      </tr>
                      {this.state.selectedItemId === item.Id && (
                        <tr>
                          <td colSpan="3">
                            <div>
                              <p>{item.details}</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>

          <button
            className="btn btn-primary floatRight"
            onClick={this.handlePrint}
          >
            PRINT HERE
          </button> */}
          <div>
            {/* Your table component */}
            <div
              className="table-responsive mt-5"
              ref={this.printableRef}
              id="printablediv"
            >
              <div
                class="table-responsive mt-5 "
                ref={this.printableDivRef}
                id="printableRef"
              >
                <table className="table table-bordered table-striped table-hover shadow-sm">
                  <thead className="thead-dark">
                    <tr>
                      <th>Date</th>
                      <th>Desc</th>
                      <th>Debit</th>
                      <th>Credit</th>
                      <th>Balance</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                    <tbody>
                    {this.state.Data.map((user) => (
                      <tr>
                        <td>{user.TransDate}</td>
                        <td>{user.Remark}</td>
                        <td>{formatAmount(user.ACDBAmount)}</td>
                        <td>{formatAmount(user.ACCRAmount)}</td>
                        <td>{formatAmount(user.ACBalance)}</td>
                        <td>
                          <button
                            className="btn btn-primary"
                            onClick={() =>
                              this.handleDetails(user.OriginTransID)
                            }
                          >
                            View More
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* <table class="table table-striped">
                  <thead>
                    <tr>
                      {this.state.Headers !== undefined &&
                      this.state.Headers !== null &&
                      this.state.Headers.length !== 0
                        ? this.state.Headers.map((item, index) => {
                            return <th className="th">{item}</th>;
                          })
                        : null}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.Data !== undefined &&
                    this.state.Data !== null &&
                    this.state.Data.length !== 0
                      ? this.state.Data.map((item, index) => {
                          return (
                            <React.Fragment key={item.Id}>
                              <tr
                                className="tr"
                                onClick={() => this.handleItemClick(item.Id)}
                              >
                                {this.state.Headers.map((header, index) => {
                                  return (
                                    <td>
                                      {Object.entries(item).map(
                                        ([key, value]) => (
                                          <div>
                                            {header === key ? (
                                              <div> {value}</div>
                                            ) : null}
                                          </div>
                                        )
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                              {this.state.selectedItemId === item.Id && (
                                <tr>
                                  <td colSpan="3">
                                    <div>
                                      <p>{item.details}</p>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })
                      : null}
                  </tbody>
                </table> */}
              </div>
            </div>

            {/* ReactToPrint component */}
            <ReactToPrint
              trigger={() => (
                <button className="btn btn-primary floatRight">Print</button>
              )}
              content={() => this.printableRef.current}
            />
          </div>
          <Modal
            show={this.state.showClients}
            onHide={this.closeClients}
            animation={false}
          >
            <Modal.Header>
              <Modal.Title>Select Client</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Here"
                  onChange={(text) => this.onSearch(text)}
                />
                {this.state.clients.map((item, index) => {
                  return (
                    <div className="pt-3" key={index}>
                      <div
                        className="btn"
                        onClick={() => this.onSelectClient(item.id)}
                      >
                        {item.name}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Modal.Body>
          </Modal>

          <PieChart width={400} height={400}>
            <Pie
              dataKey="Amount"
              isAnimationActive={false}
              data={this.state.data}
              cx="50%"
              cy="50%"
              outerRadius={80}
              fill="#8884d8"
              label
            />

            <Tooltip />
          </PieChart>
        </div>
      );
    } else {
      return (
        <div
          className="container-fluid v-100"
          style={
            this.state.items !== undefined && this.state.getButton
              ? stylesASAP.reportcolor
              : stylesASAP.reportcolor
          }
        >
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className="btn"
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}
          {!this.state.showRequiredAlert ? null : (
            <div className="col alert alert-danger">
              {this.state.alertString} are required fields that should be
              filled.
            </div>
          )}
          {!this.state.alertOffline ? null : (
            <div className="col alert alert-danger">
              {" "}
              Please Connect To the internet.
            </div>
          )}
          {!this.state.nodata ? null : (
            <div className="col alert alert-danger"> No Data Found !!!</div>
          )}
          <div className="row pt-3" style={stylesASAP.above}>
            <div className="col">
              <ArrowBackCircle
                className="btn"
                onClick={() => this.props.history.push("./TransactionsPage")}
                color={"#00bfff"}
                height="50px"
                width="50px"
              />
            </div>
            <h1
              className="col d-flex align-items-center justify-items-center"
              style={stylesASAP.reportsTitle}
            >
              Reports
            </h1>
            <div className="col"></div>
          </div>
          <div className=" row mt-5 m-1">
            <div className="col-sm-6">
              <h6>Please Select a Client : </h6>
              <input
                className="select-client form-control"
                defaultValue={
                  this.state.loading ||
                  this.state.clientIndex === "-1" ||
                  this.state.clientIndex === -1
                    ? ""
                    : this.state.clients[this.state.clientIndex].name
                }
                onClick={this.state.disableClient ? null : this.showClients}
                placeholder="Choose a client"
              />
            </div>
            <div className="col-sm-6">
              <h6>Type : </h6>
              <select
                className="select-type form-control"
                value={this.state.selectedType}
                onChange={(e) => this.onChangetype(e)}
              >
                {this.state.types.map((item, index) => {
                  if (index === 0) {
                    return (
                      <option value={index} disabled>
                        {item}
                      </option>
                    );
                  } else {
                    return <option value={index}>{item}</option>;
                  }
                })}
              </select>
            </div>
          </div>
          <div className=" row mt-5 m-1">
            <div className="col-sm-4">
              <h6>From Date: </h6>
              <DatePicker
                className="form-control"
                selected={this.state.fromDate}
                onChange={(date) => this.onSelectFromDate(date)}
                dateFormat="MM-dd-yyyy"
              />
            </div>
            <div className="col-sm-4">
              <h6>To Date: </h6>
              <DatePicker
                className="form-control"
                selected={this.state.toDate}
                onChange={(date) => this.onSelectToDate(date)}
                 dateFormat="MMMM d, yyyy"
              />
            </div>
            {/* {this.state.selectedType !== 0 ? (
              <div className="col-4 mt-4 ">
                <div
                  className="btn-sm text-center "
                  data-toggle="modal"
                  data-target="#myModal"
                  style={stylesASAP.wideButton}
                  onClick={this.onGetReport}
                >
                  Get Report
                </div>
              </div>
            ) : (
              <div className="col-4 mt-4 ">
                <div
                  className="btn-sm text-center invisible"
                  data-toggle="modal"
                  data-target="#myModal"
                  style={stylesASAP.wideButton}
                  onClick={this.onGetReport}
                >
                  Get Report
                </div>
              </div>
            )} */}
          </div>
          <div className="pt-3 text-center">
            <div className="spinner-border" style={stylesASAP.spinner}></div>
          </div>
        </div>
      );
    }
  }
}
